// function isValidDomain(origin, customDomain = '') {
//   // Domain and api domain
//   const params = new URLSearchParams(window.location.search);
//   const env = params.get('env') || '';
// let allowedOrigins = [
//     'https://www.gevme.com',
//     'https://showcase-dev.gevme.com',
//     'https://showcase-dev.gev.me',
//     'https://showcase.gev.me',
//     'https://live.gev.me',
//     'https://live-dev.gevme.com',
//     'https://live.gevme.com',
//     'https://admin.gevme.com',
//     'https://admin.gev.me',
//     'https://admin-dev.gevme.com',
//   ];

//   if (
//     (process.env.NODE_ENV === 'development' ||
//       process.env.NODE_ENV === 'LOCAL') &&
//     env === 'localhost'
//   ) {
//     allowedOrigins.push('http://localhost:3001');
//   }

//   if (customDomain) {
//     allowedOrigins.push(customDomain);
//   }

//   return allowedOrigins.some((domain) => origin === domain);
// }

function handleMessageActivity(event, iframeId) {
  try {
    let dataObj = JSON.parse(event.data);
    switch (dataObj.eventType) {
      case 'listenerAttached':
        document.getElementById(iframeId).contentWindow.postMessage(
          JSON.stringify({
            action: 'gevme-json',
            data: JSON.stringify(window.GEVME),
          }),
          '*'
        );
        break;
      default: {
      }
    }
  } catch (error) {
    console.error(error);
  }
}
class GevmeActivityFeed extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var iframe = document.createElement('iframe');
    //eventually the base URI needs to be updated to /widgets

    var redirectBaseURI = `${
      window?.GEVME?.setting?.customDomain || process.env.TEMPLATE_APP_DOMAIN
    }/widgets`;
    var width = '100%',
      height,
      feedId,
      showAddActivity,
      feedGroup,
      showChannels,
      iframeId = `GevmeActivityFeed${Date.now()}`;
    try {
      var activityFeedObj = JSON.parse(this.getAttribute('settings'));
      width = activityFeedObj?.style?.width;
      height = activityFeedObj?.style?.height;
      feedId = activityFeedObj?.feedId;
      showAddActivity = activityFeedObj?.showAddActivity;
      feedGroup = activityFeedObj?.feedGroup;
      showChannels = activityFeedObj?.showChannels;
    } catch (error) {}

    iframe.id = iframeId; // unique id
    iframe.name = 'GevmeActivityFeed';
    iframe.title = 'Gevme Activity Feed';
    iframe.sandbox =
      'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin';
    iframe.allowFullScreen = true;
    iframe.seamless = true;
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'no-referrer';
    iframe.src =
      `${redirectBaseURI}/activityFeed?` +
      `slug=${window?.GEVME?.livepage?.slug}` +
      `${window?.GEVME?.isPreview ? '&isPreview=true' : ''}` +
      `${showAddActivity ? `&showAddActivity=${showAddActivity}` : ''}` +
      `${feedId ? `&feedId=${feedId}` : ''}` +
      `${feedGroup ? `&feedGroup=${feedGroup}` : ''}` +
      `${showChannels ? `&showChannels=${showChannels}` : ''}`;
    iframe.width = width;

    iframe.frameBorder = '0';
    this.append(iframe);

    // IFrame Auto-Resizer makes the widget look like it is part of the page
    // https://github.com/davidjbradshaw/iframe-resizer
    var iframeResizer = document.createElement('script');
    iframeResizer.id = 'activity-feed-iframeResizer';
    iframeResizer.type = 'text/javascript';
    iframeResizer.src = `${process.env.PUBLIC_URL}/static/sdks/plugins/iframeResizer.min.js`;
    iframeResizer.onload = () =>
      iFrameResize(
        {
          // log: true,
          onMessage: function (messageData) {
            // TODO: simplify scrollTo feature
            document
              .getElementsByClassName('gevme-template-content')[0]
              ?.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
              });
          },
        },
        `#${iframe.id}`
      );
    this.append(iframeResizer);

    window.addEventListener('message', (e) => {
      if (isValidDomain(e.origin, window?.GEVME?.setting?.customDomain)) {
        handleMessageActivity(e, iframeId);
      }
    });
  }
}
window.customElements.define('gevme-activity-feed', GevmeActivityFeed);
